import React from "react"
export function VegMeals(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__veg-meals"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M17.25 14a1.25 1.25 0 01.128 2.494l-.128.006-.35-.001a1.5 1.5 0 01-1.215 1.474l-.14.02L15.4 18H4.6a1.5 1.5 0 01-1.493-1.356L3.1 16.5h-.35a1.25 1.25 0 01-.128-2.494L2.75 14h14.5zm0 1H2.75a.25.25 0 00-.057.493l.057.007h1.526l-.16.625-.012.061-.004.064v.25a.5.5 0 00.41.492L4.6 17h10.8a.5.5 0 00.492-.41l.008-.09v-.25l-.004-.064-.012-.061-.16-.624 1.526-.001a.25.25 0 00.057-.493L17.25 15zM3.406 1.52c3.54 1.055 6.148 3.049 7.8 5.972.245.435.463.877.652 1.329 1.082-1.153 2.484-1.987 4.196-2.5a.5.5 0 01.63.363c.55 2.308.383 4.42-.504 6.316h-1.123l.101-.187c.745-1.464.997-3.078.75-4.853l-.055-.358-.029-.153-.13.046c-1.429.532-2.575 1.329-3.445 2.396.315.998.5 2.035.555 3.109h-1.001c-.1-1.791-.59-3.461-1.468-5.016a11.575 11.575 0 00-.801-1.23l-1.397 3.2L9.887 13H8.731l-1.454-2.534-3.055-.389c.17.404.366.8.586 1.189l.18.306c.307.51.648.985 1.021 1.43L4.74 13a12.613 12.613 0 01-.801-1.243C2.288 8.836 1.903 5.536 2.777 1.884a.5.5 0 01.63-.363zm-.02 5.301c.08.755.229 1.487.45 2.198l2.817.359-1.229-2.14-2.037-.417zm3.71-2.45L6.308 6.77l1.208 2.104L8.82 5.89a11.01 11.01 0 00-1.723-1.52zM3.44 3.784c-.09.684-.128 1.352-.116 2.005l1.436.293-1.32-2.298zm.577-1.009l1.621 2.828.59-1.795c-.68-.4-1.416-.743-2.211-1.033z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__vegetarian"
        />
      </g>
    </svg>
  )
}
